export const themeC = {
  name: "黑白簡約",
  colors: {
    bg: "#FFFFFF",
    bgSecondary: "#F5F5F5",
    text: "#000000",
    textSecondary: "#4A4A4A",
    textMuted: "#6A6A6A",
    accent: "#000000",
    accentText: "#FFFFFF",
    accentAlt: "#000000",
    accentWarm: "#000000",
    accentOrange: "#000000",
    available: "#000000",
    availableText: "#FFFFFF",
    claimed: "#CCCCCC",
    cardBg: "#FFFFFF",
    cardBorder: "#EEEEEE",
    overlay: "rgba(255,255,255,0.85)",
    heroBg: "#000000",
    heroText: "#FFFFFF",
  },
  fonts: {
    heading: "'Montserrat', 'Noto Sans TC', sans-serif",
    body: "'Noto Sans TC', sans-serif",
    accent: "'Montserrat', sans-serif",
  },
  fontUrls: [
    "https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap",
  ],
  radius: { sm: "0px", md: "0px", lg: "0px", full: "0px" },
  spacing: { cardGap: "2px", sectionGap: "64px", pagePadding: "20px" },
  effects: {
    cardShadow: "none",
    cardHoverShadow: "none",
    bgTexture: false,
    textureOpacity: 0,
  },
};
